const languageDetector = () => {
  if (
    (document &&
      document.location &&
      document.location.href &&
      document.location.href.toLowerCase().indexOf('/achd/') !== -1) ||
    (document &&
      document.location &&
      document.location.href &&
      document.location.href.toLowerCase().indexOf('achd.ca') !== -1)
  ) {
    return 'fr'
  }
  if (process.env.NODE_ENV === 'development') {
    return 'en'
  }
  return 'en'
}

export default languageDetector
